import { ZERO, ONE, TWO, FEW, MANY, OTHER } from './constant';
import { LocaleName, RelativeTimePluralType } from './type';

export const getPluralType = (num: number, locale: LocaleName): RelativeTimePluralType => {
  switch (locale) {
    case 'ar':
      if (num === 0) {
        return ZERO;
      }
      if (num === 1) {
        return ONE;
      }
      if (num === 2) {
        return TWO;
      }
      if (num % 100 >= 3 && num % 100 <= 10) {
        return FEW;
      }
      if (num % 100 > 10) {
        return MANY;
      }
      return OTHER;

    case 'bn':
    case 'nl':
    case 'en':
    case 'fil':
    case 'fi':
    case 'de':
    case 'el':
    case 'hu':
    case 'it':
    case 'pt':
    case 'es':
    case 'sv':
    case 'ta':
    case 'tr':
    case 'et':
    case 'af':
    case 'bg':
    case 'ml':
    case 'mr':
    case 'or':
    case 'sw':
    case 'te':
    case 'ur':
    case 'uz':
    case 'da':
    case 'nb':
      if (num === 1) {
        return ONE;
      }
      return OTHER;

    case 'ceb':
      if (num % 10 === 4 || num % 10 === 6 || num % 10 === 9) {
        return ONE;
      }
      return OTHER;

    case 'cs':
      if (num === 1) {
        return ONE;
      }

      if (num % 10 >= 2 && num % 10 <= 4) {
        return FEW;
      }

      if (!Number.isInteger(num)) {
        return MANY;
      }

      return OTHER;

    case 'fr':
    case 'gu':
    case 'hi':
    case 'pa':
    case 'kn':
      if (num === 0 || num === 1) {
        return ONE;
      }
      return OTHER;

    case 'he':
      if (num === 1) {
        return ONE;
      }
      if (num === 2) {
        return TWO;
      }
      if (num !== 0 && num % 10 === 0) {
        return MANY;
      }
      return OTHER;

    case 'pl':
    case 'ru':
    case 'uk':
      if (num === 1) {
        return ONE;
      }
      if (num % 10 >= 2 && num % 10 <= 4) {
        return FEW;
      }
      if (Number.isInteger(num)) {
        return MANY;
      }
      // float
      return OTHER;

    case 'ro':
      if (num === 1) {
        return ONE;
      }

      if (num === 0 || (num % 100 >= 2 && num % 100 <= 19)) {
        return FEW;
      }
      return OTHER;

    case 'hr':
      if (num % 10 === 1) {
        return ONE;
      }

      if (num % 10 === 2 || num % 10 === 3 || num % 10 === 4) {
        return FEW;
      }

      return OTHER;

    case 'lt':
      if (num % 10 === 1) {
        return ONE;
      }

      if (num % 10 === 0) {
        return OTHER;
      }

      if (Number.isInteger(num)) {
        return FEW;
      }

      // float
      return MANY;

    case 'lv':
      if (num % 10 === 0) {
        return ZERO;
      }

      if (num % 10 === 1) {
        return ONE;
      }

      return OTHER;

    case 'sk':
      if (num % 10 === 1) {
        return ONE;
      }

      if (num % 10 === 2 || num % 10 === 3 || num % 10 === 4) {
        return FEW;
      }

      if (!Number.isInteger(num)) {
        return MANY;
      }

      return OTHER;

    default:
      return OTHER;
  }
};
